import * as angular from 'angular';
import * as _ from "lodash";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import {Strings} from "../../shared/config/constant.module";
import DateUtilityService from "../../services/utility/dateutility.service";
import ShopServiceName, {ShopService} from "../../services/shops/shops.service";
import FillOutCheckListName, {openFillOutCheckList} from "../../controllers/checks/fillOutCheckList.controller";
import template from "./blockedSignOff.tpl.html";
import AddDowntimeName, {openAddDowntime} from "../../controllers/downtime/addDowntime.controller";
import {DowntimeActivity} from "../../models/activity/gobActivity";
import {SectionActivity} from "../../models/activity/shopActivity";

let requires = [ShopServiceName, FillOutCheckListName, AddDowntimeName];

export function openBlockedSignOff(params: BlockedSignOffControllerParams,
                                   $modal: mm.foundation.modal): mm.foundation.modalInstance {
  return $modal.open({
    template: template,
    controller: 'BlockedSignOffCtrl as vm',
    resolve: {
      params: () => params
    }
  });
}

export interface BlockedSignOffController {
  openDowntimes: apsViewModels.DowntimeActivity[];
  blockingChecklists: apsViewModels.CheckListInstanceListItem[];
  loading: boolean;

  formatTime(time: any): string;
  openDowntime(downtime: DowntimeActivity): void;
  openChecklist(checklist: apsViewModels.CheckListInstanceListItem): void;
  dismissDowntime(downtime: DowntimeActivity): void;
  dismissChecklist(checklist: apsViewModels.CheckListInstanceListItem): void;

  workItemsNotDismissed(): boolean;
  signOff(): void;
}

export interface BlockedSignOffControllerParams {
  shopId: string;
  openDowntimes: apsViewModels.DowntimeActivity[];
  blockingChecklists: apsViewModels.CheckListInstanceListItem[];
  signOff(): void;
}

  interface Action {
    () : void;
  }

class BlockedSignOffCtrl implements BlockedSignOffController {

  openDowntimes: apsViewModels.DowntimeActivity[];
  blockingChecklists: apsViewModels.CheckListInstanceListItem[];
  loading: boolean;
  timeZoneId: string;
  $modal: mm.foundation.modal;
  $modalInstance: mm.foundation.modalInstance;
  signOffImpl: Action;
  private shop: apsViewModels.ShopConfigurationWithShifts;

  constructor(params: BlockedSignOffControllerParams,
              shopService: ShopService,
              $modal: mm.foundation.modal,
              $modalInstance: mm.foundation.modalInstance) {
    this.loading = true;
    this.timeZoneId = Strings.DEFAULT_TIMEZONE;
    this.$modal = $modal;
    this.$modalInstance = $modalInstance;
    this.signOffImpl = params.signOff;

    shopService.getShopConfiguration(params.shopId)
      .then(shop => {
        this.shop = shop;
        this.timeZoneId = shop.timeZoneId;
        this.openDowntimes = params.openDowntimes;
        this.blockingChecklists = params.blockingChecklists;
        this.loading = false;
      });
  }

  formatTime(time) {
    return DateUtilityService.formatTime(time, this.timeZoneId);
  }

  openDowntime(downtime: DowntimeActivity) {
    let vm = this;

    let fakeSectionForAddDowntimeCtrl: SectionActivity = {
      name: null,
      machine: {
        id: downtime.isMachineId,
        sections: [],
        latestTools: null,
        gobs: [],
        name: '',
        machineLevelActivity: null,
        shop: null,
        number: null
      },
      gobs: [],
      latestTools: null,
      sectionNumber: null
    };

    if (!_.isNull(downtime.section)) {
      fakeSectionForAddDowntimeCtrl.name = downtime.section.toString(10);
      fakeSectionForAddDowntimeCtrl.machine.sections.push(fakeSectionForAddDowntimeCtrl);
    }

    this.$modalInstance.close();

    openAddDowntime({
      section: fakeSectionForAddDowntimeCtrl,
      shopId: this.shop.id,
      date: downtime.downtimeStart,
      timeZoneId: vm.timeZoneId,
      downtime: downtime,
      canComment: null,
      readOnly: null
    }, this.$modal);
  }

  openChecklist(checklist: apsViewModels.CheckListInstanceListItem) {
    this.$modalInstance.close();
    openFillOutCheckList({
      checkListId: checklist.checkListId,
      instanceId: checklist.id,
      shopId: this.shop.id,
      plantId: this.shop.plantId,
      tankId: this.shop.tankId,
      plantLocationId: checklist.plantLocationId,
      scheduledOn: checklist.scheduledOn
    }, this.$modal);
  }

  dismissDowntime(downtime: apsViewModels.DowntimeActivity) {
    (<any>downtime).userSignoffDismissed = true;
  }

  dismissChecklist(checklist: apsViewModels.CheckListInstanceListItem) {
    (<any>checklist).userSignoffDismissed = true;
  }

  workItemsNotDismissed() {
    let checklistsActive = this.blockingChecklists && _.some(this.blockingChecklists, (c) => {
      return !(<any>c).userSignoffDismissed;
    });

    let downtimesActive = this.openDowntimes && _.some(this.openDowntimes, (d) => {
        return !(<any>d).userSignoffDismissed;
    });

    return checklistsActive || downtimesActive;
  }

  signOff() {
    if (this.workItemsNotDismissed()) {
      return;
    }

    if (this.signOffImpl) {
      this.$modalInstance.close();
      this.signOffImpl();
    }
  }
}

export default angular.module('aps.controller.blockedSignOff', requires)
  .controller('BlockedSignOffCtrl', BlockedSignOffCtrl)
  .name;




// WEBPACK FOOTER //
// ./src/app/layout/header/blockedSignOff.controller.ts